import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qvs-login-page-header',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './login-page-header.component.html',
  styleUrls: ['./login-page-header.component.scss']
})
export class LoginPageHeaderComponent {
  @Input() title = 'ebanking.login.WELCOME';
}
